import { FC } from "react";
// MUI
import { Box } from "@mui/material";
// 
import ContactsCreateButton from "./ContactsCreateButton";
import ContactsFilter from "./ContactsFilter";

const ContactsHeader:FC = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <ContactsFilter />
      <Box flexGrow="1" />
      <ContactsCreateButton />
    </Box>
  )
}

export default ContactsHeader;
